import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b3557180"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["value", "name", "checked"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", {
    class: "ef-radio",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.set()))
  }, [
    _createElementVNode("input", {
      type: "radio",
      value: _ctx.value,
      name: _ctx.name,
      checked: _ctx.checked
    }, null, 8, _hoisted_1),
    _createElementVNode("span", null, _toDisplayString(_ctx.label), 1),
    _hoisted_2
  ]))
}